import { UserNoticeSurface } from '@/generated/graphql'
import type { UserNoticeSource } from './analytics'

// The app's own surfaces, by path root. Account management (/membership-info,
// /update-payment-method, /cancel-subscription…) is deliberately absent: the screens' only
// CTA is a payment page, so a dead-end covering those would block the way out of itself.
// An unrecognised route shows nothing, which is the direction that cannot trap anyone.
const APP_ROOTS = [
  '/plan',
  '/today',
  '/discovery',
  '/profile',
  '/onboarding',
  '/return',
]

export function isAppSurface(pathname: string): boolean {
  return APP_ROOTS.some(
    (root) => pathname === root || pathname.startsWith(`${root}/`),
  )
}

// A surface is a place the user is between tasks. Where they are mid-task, nothing is
// ASKED: the day's show would be spent on a screen we must not cover, and falling back to
// LAUNCH would drop a full-screen notice onto Settings or onto a running practice. A
// dead-end is not bound by this — it asks nothing, so it spends nothing.
export function isMidTask(pathname: string): boolean {
  return (
    pathname.startsWith('/profile/') || pathname.startsWith('/today/practice/')
  )
}

// Profile is its own surface server-side, with its own daily quota. Everywhere else,
// including the day route outside the layout, reads as LAUNCH.
export function noticeSurface(pathname: string): UserNoticeSurface {
  return pathname === '/profile'
    ? UserNoticeSurface.Profile
    : UserNoticeSurface.Launch
}

export function noticeSource(pathname: string): UserNoticeSource {
  return pathname === '/profile' ? 'profile' : 'launch'
}
